import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";

@Component({
  selector: 'previewCorrespondence',
  styleUrls: ['./previewCorrespondence.component.scss'],
  templateUrl: './previewCorrespondence.component.html'
})

export class PreviewCorrespondenceComponent implements OnInit {

  correspondenceModalLetterText: string = '';
  letterBody: string = '';

  constructor(
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<PreviewCorrespondenceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.letter != null && this.data.letter != undefined) {
      this.correspondenceModalLetterText = this.data.letter;
      this.letterBody = this.data.letter;
    }
  }

  ngOnInit(): void {
  }

  copyToClipBoard(): void {
    this.sharedService.copyToClipboard(this.correspondenceModalLetterText);
  }

  return(): void {
    this.dialogRef.close();
  }
}